import React from "react";
import analyticsService from "../AnalyticsService";

const getErrorDetails = (error, info = {}) => ({
  error_message: error?.message || "Unknown error",
  stack_trace: error?.stack || null,
  component: info?.componentStack || "global",
  screen: globalThis?.location?.pathname,
  status_code: info?.status_code || null,
  browser: globalThis?.navigator?.userAgent || "unknown",
  timestamp: new Date().toISOString(),
});

export const setupGlobalErrorTracking = () => {
  const onWindowError = (event) => {
    analyticsService.trackError(
      getErrorDetails(event?.error || new Error(event?.message || "window_error"), {
        component: "window.onerror",
      }),
    );
  };

  const onUnhandledRejection = (event) => {
    const reason = event?.reason;
    const error = reason instanceof Error ? reason : new Error(String(reason || "promise_rejection"));

    analyticsService.trackError(
      getErrorDetails(error, {
        component: "unhandledrejection",
      }),
    );
  };

  globalThis.addEventListener("error", onWindowError);
  globalThis.addEventListener("unhandledrejection", onUnhandledRejection);

  return () => {
    globalThis.removeEventListener("error", onWindowError);
    globalThis.removeEventListener("unhandledrejection", onUnhandledRejection);
  };
};

export class AnalyticsErrorBoundary extends React.Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    analyticsService.trackError(getErrorDetails(error, info));
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || null;
    }

    return this.props.children;
  }
}
